import styled from 'styled-components'
import Checkboxes from 'components/Form/CheckboxSkill'
import { Checkbox } from 'antd'
import Flex from 'components/Flex'


export const StyledGroup = styled(Checkbox.Group)`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
 
.ant-checkbox-inner {
  height: 18px; 
  width: 18px;
  border-radius: 5px;

  border: 2px solid #CCCFD6; /* Black border for enabled (not checked) checkboxes */
}
.ant-checkbox-input:checked + .ant-checkbox-inner {
  border:none
}

.ant-checkbox:hover .ant-checkbox-inner {
  border: 2px solid #CCCFD6; /* Replace 'your-hover-color' with the desired color value */
}

`

export const StyledGroup1 = styled(Checkbox.Group)`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
 
.ant-checkbox-inner {
  height: 18px; 
  width: 18px;
  border-radius: 5px;
background: #F6F6F6 !important;
  border: 2px solid #B4B4B4; /* Black border for enabled (not checked) checkboxes */
}
.ant-checkbox-input:checked + .ant-checkbox-inner {

  border:none;
  background-color: #3249D7 !important;
    border-color: #3249D7 !important;
}

.ant-checkbox:hover .ant-checkbox-inner {
  border: 2px solid #CCCFD6; /* Replace 'your-hover-color' with the desired color value */
}
  

`
export const StyledCheckbox = styled(Checkboxes)`

`
export const StyledCheckbox2 =styled(Checkbox)`
color: #303030 !important;
`
export const StyledCheckbox1 = styled(Checkboxes)`
font-size: 12px !important;
  margin-left: 0 !important;
  padding: 10px !important;
`
export const StyledOutline = styled(Flex)`
padding: 10px;
margin: 10px;
border: 1px solid #e6e7ea;
borderRadius: 10px;
`